import React from 'react';

import styled from '@emotion/styled';

import { flex } from 'src/styles/utils';

import Tag from './Tag';
import { TagsProps } from './types';

const Tags: React.FC<TagsProps> = ({ spaceX, tags, spaceY }) => {
  const TagsWrapper = styled.div`
    width: 100%;
    ${flex('row', 'start')};
    gap: ${spaceX}px;
    margin-top: ${spaceY}px;
    flex-wrap: wrap;
  `;

  const renderTags = () => {
    return tags.map((tag, index) => {
      return <Tag key={index} {...tag} showDot={tag.showDot} index={index} />;
    });
  };

  return <TagsWrapper>{renderTags()}</TagsWrapper>;
};

export default Tags;
